<div #mindMap class="mind-map">
  <div #moveContainer class="move-container">
    <ng-container *ngTemplateOutlet="recTree; context: { $implicit: interface.tree, sequence: rootLocationSequence }"></ng-container>
  </div>
</div>

<ng-content select="dt-hierarchy-toolbar"></ng-content>
<ng-content select="[overlay]"></ng-content>

<ng-template #recTree let-tree let-sequence="sequence">
  <div class="flex-container">
    <!-- Arm to parent-->
    @if (!sequence.isRoot()) {
      <div
        class="arm"
        [class.root]="sequence.value.length === 1"
        (click)="sequence.value.length > 1 && nodeState.collapseNode(sequence.getParent())"
        (mousedown.outside-zone)="onArmMouseDown($event)"
      >
        <div class="segment up"></div>
        <div class="segment base"></div>
        <div class="segment down"></div>
      </div>
    }

    <!-- Node -->
    <dt-hierarchy-node [locationSequence]="sequence" [tree]="tree" [rootTooltip]="rootTooltip"></dt-hierarchy-node>

    <!-- Children-->
    @if (tree.children?.length > 0) {
      @if (nodeState.isCollapsed(sequence)) {
        <div class="collapse-container" (click)="nodeState.expandNode(sequence)" (mousedown.outside-zone)="onArmMouseDown($event)">
          <mat-icon>add</mat-icon>
        </div>
      } @else {
        <div
          class="arm parent-to-child"
          [class.root]="sequence.isRoot()"
          (click)="!sequence.isRoot() && nodeState.collapseNode(sequence)"
          (mousedown.outside-zone)="onArmMouseDown($event)"
        >
          <div class="segment base"></div>
        </div>
        <div>
          @for (child of tree.children; track child; let childIndex = $index) {
            <ng-container
              *ngTemplateOutlet="
                recTree;
                context: {
                  $implicit: child,
                  sequence: sequence.getChild(childIndex),
                }
              "
            ></ng-container>
          }
        </div>
      }
    }
  </div>
</ng-template>
